var e = /* @__PURE__ */ ((o) => (o.FACEBOOK = "facebook", o.INSTAGRAM = "instagram", o.LINKEDIN = "linkedin", o.REDDIT = "reddit", o.RESTREAM = "restream", o.YOUTUBE = "youtube", o.TIKTOK = "tiktok", o.TWITTER = "twitter", o.TWITCH = "twitch", o.WHATSAPP = "whatsapp", o))(e || {});
const r = {
  twitter: {
    name: "X",
    color: "#000",
    secondaryColor: "#FFF"
  },
  facebook: {
    name: "Facebook",
    color: "#1877F2",
    secondaryColor: "#FFF"
  },
  instagram: {
    name: "Instagram",
    color: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
    secondaryColor: "#FFF"
  },
  linkedin: {
    name: "LinkedIn",
    color: "#0A66C2",
    secondaryColor: "#FFF"
  },
  youtube: {
    name: "YouTube",
    color: "#FF0000",
    secondaryColor: "#FFF"
  },
  tiktok: {
    name: "TikTok",
    color: "#FFFFFF",
    secondaryColor: "#000"
  },
  reddit: {
    name: "Reddit",
    color: "#FF5700",
    secondaryColor: "#FFF"
  },
  restream: {
    name: "Restream",
    color: "#000000",
    secondaryColor: "#FFF"
  },
  twitch: {
    name: "Twitch",
    color: "#6441A4",
    secondaryColor: "#FFF"
  },
  whatsapp: {
    name: "WhatsApp",
    color: "linear-gradient(36deg, rgba(45,182,64,1) 0%, rgba(88,207,99,1) 100%)",
    secondaryColor: "#FFF"
  }
};
export {
  e as Brand,
  r as Brands
};
